import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Tab, Tabs, Typography } from '@mui/material'
import React, { useState } from 'react'
import MailReminder from './mailReminder';
import WhatsappReminder from './whatsappReminder';
import { useLocation } from 'react-router-dom';

const NotificationNotify = () => {
      const [value, setValue] = useState(0);
      const location = useLocation();
        const [selectedOption, setSelectedOption] = useState('');
        type LocationState = {
  selectedClients: any[]; // replace `any` with actual type if known
  trigger: string;
};
  const { selectedClients, trigger } = (location.state || {}) as LocationState;

      // const selectedClients = location.selectedClients;
      console.log(selectedClients,'selectedClients')

     const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };
    
  return (
  <Box sx={{ width: '100%',height:"100vh", bgcolor: 'background.paper',padding:"2px",mt:"2px"}}>
          <Box sx={{  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", "padding":"4px","margin":"15px","height":"98%","borderRadius":"5px"}}>
    
      <FormControl component="fieldset" sx={{margin:"15px"}}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Choose Notification Type
        </Typography>
        <RadioGroup
          row
          value={selectedOption}
          onChange={handleChange}
          name="notification-method"
        >
          <FormControlLabel value="email" control={<Radio />} label="Email" />
          <FormControlLabel value="whatsapp" control={<Radio />} label="WhatsApp" disabled/>
        </RadioGroup>
      </FormControl>

{selectedOption === 'email' && <MailReminder selectedClients={selectedClients} trigger={trigger} />}
{selectedOption === 'whatsapp' && <WhatsappReminder selectedClients={selectedClients} />}
</Box>
    </Box>  )
}

export default NotificationNotify